'use strict';

//BURGER MENU

var burgerMenu = document.getElementById('burger-menu');
var menu = document.getElementById('menu');

burgerMenu.addEventListener('click', function () {

menu.classList.toggle('active');
burgerMenu.classList.toggle('open');
});

//ANIMATION SCROLL

const faders = document.querySelectorAll('.fade-in');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  });
});

faders.forEach(el => observer.observe(el));